// src/context/AuthContext.js
import { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

export const USUARIOS = [
  { usuario: 'admin',      pin: '0521', rol: 'admin',      nombre: 'Administrador'   },
  { usuario: 'gaby',       pin: '2828', rol: 'admin',  nombre: 'Gabriela Chevez' },
  { usuario: 'davidv', pin: '2016', rol: 'tecnico', nombre: 'David Vite'       },
  { usuario: 'alfonsogab', pin: '2016', rol: 'tecnico', nombre: 'Alfonso Loza'       },
];

// Páginas permitidas por rol
// admin → todo (sin restricción)
// supervisor → todo excepto Finanzas
// tecnico → dashboard, ordenes, consulta, garantias
export const PERMISOS = {
  admin: null, // null = sin restricciones
  supervisor: [
    '/dashboard',
    '/ordenes',
    '/consulta',
  ],
  tecnico: [
    '/ordenes',
    '/consulta',
    '/garantiasmodule',
    '/tareas',
    '/facturas',
    '/vehiculos',
    '/requerimientos',
  ],
};

export function tieneAcceso(rol, path) {
  const permisos = PERMISOS[rol];
  if (!permisos) return true; // admin → acceso total
  return permisos.some(p => path.startsWith(p));
}

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(
    JSON.parse(sessionStorage.getItem('zoler_usuario') || 'null')
  );

  const login = (u) => {
    setUsuario(u);
    sessionStorage.setItem('zoler_usuario', JSON.stringify(u));
  };

  const logout = () => {
    setUsuario(null);
    sessionStorage.removeItem('zoler_usuario');
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);